<template>
    <div class="footer">
      <div class="footer-left">
        <img src="@/assets/img/home/shopLogo.png" alt="">
        <div class="footer-left-title">
          Global Brands, Local Retailers, One Entrepreneur Dream!
          <br>
          We strive to build a wholesale community of a shared future.
        </div>
        <div class="left-reserved">
          <span>3427 Oakcliff Rd Ste 100, Atlanta, GA, 30340 USA</span>
          <span style="margin-top: 15px;">Copyright © 2025 ShopVidi Inc.</span>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-right-list">
          <ul>
            <li class="right-list-title">Company</li>
            <li @click="open('/about')">Our Story</li>
            <li @click="open('/contact')">Contact Us</li>
          </ul>
        </div>
        <div class="footer-right-list">
          <ul>
            <li class="right-list-title">Commerce Hub</li>
            <li @click="open('https://brand.shopvidi.com/',1)" class="sellShop">Brand Partner</li>
            <li @click="open('https://partner.shopvidi.com/',1)">Wholesale Partner</li>
            <li @click="open('/vilocal')">ViLocal</li>
          </ul>
        </div>
        <div class="footer-right-list">
          <ul>
            <li class="right-list-title">Support</li>
            <li @click="open('/credit-payment')">Net 60 Terms</li>
            <li @click="open('/privacy')">Privacy Policy</li>
            <li @click="open('/return-policy')">Return Policy</li>
            <li @click="open('/term-service')">Terms of Use</li>
            <li @click="open('http://help.shopvidi.com',1)">Help Center</li>
          </ul>
        </div>
        <div class="footer-right-list">
          <ul>
            <li class="right-list-title">Socials</li>
<!--
            <li @click="open('https://blog.shopvidi.com/',1)">Blog</li>
-->
            <li @click="open('https://www.facebook.com/ShopVidiHome',1)">Facebook</li>
            <li @click="open('https://www.instagram.com/shopvidiwholesale/',1)">Instagram</li>
            <li @click="open('https://www.linkedin.com/company/wholesaleshopvidi/',1)">Linkedin</li>
            <li @click="open('https://api.whatsapp.com/send?phone=%2B17736695751',1)">WhatsApp</li>
            <li @click="open('https://maps.app.goo.gl/ezFC2r8vgoyWKguT9',1)">Google Map</li>
          </ul>
        </div>
        <div class="right-reserved">
          <span>3427 Oakcliff Rd Ste 100, Atlanta, GA, 30340 USA</span>
          <span style="margin-top: 15px;">Copyright © 2025 ShopVidi Inc.</span>
          <!-- <span style="margin-top: 15px;">© 2025 ShopVidi, All Rights Reserved</span> -->
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'cust-footer',
  methods: {
    open(url, type) {
      if (type === 1) {
        window.open(url)
      } else {
        this.$router.push({
          path: url
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
ul{
  li{
    cursor: pointer;
  }
}
.footer{
  width: 100%;
  height: 320px;
  // margin-top: 100px;
  background: #232416;
  box-sizing: border-box;
  color: #ffffff;
  display: flex;
  justify-content: space-evenly;
  padding-top: 50px;
  font-family: Satoshi;
   .footer-left{
    width: 480px;
    text-align: left;
    img{
      width: 167px;
    }
    .footer-left-title{
      font-size: 18px;
      line-height: 22px;
      padding: 25px 0 77px 0;
    }
   }
  .footer-right{
    display: flex;
    width: 470px;
    justify-content: space-evenly;
    .footer-right-list{
      .right-list-title{
        padding-bottom: 17px;
        font-size: 16px;
        font-family: Satoshi-Bold;
      }
    }
    ul{
      li{
        list-style: none;
        line-height: 30px;
      }
    }
  }
}

@media screen and(min-width:750px){
  .left-reserved{
    display: flex;
    flex-direction: column;
  }
  .right-reserved{
    display: none;
  }
}
@media screen and(max-width:750px){
  .sellShop{
    display: none;
  }
  .left-reserved{
    display: none;
  }
  .right-reserved{
    display: flex;
    padding: 30px 0;
    flex-direction: column;
  }
  .footer{
    flex-wrap:wrap ;
    padding-left:18px !important;
     padding-right:12px !important;
    height: auto;
    .footer-left{
      width: 100% !important;
      .footer-left-title{
        font-size: 14px !important;
        padding-bottom: 20px !important;
      }
    }
    .footer-right{
      flex-wrap:wrap;
      justify-content: normal;
      .footer-right-list{
        width: 100% !important;
        font-size:14px !important;
        padding-top: 23px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/homeFooter.vue